import React from "react";
import { useI18n } from "@/lib/i18n";
import Seo from "@/components/Seo";
export default function Methodology() {
  const { t, locale } = useI18n();
  return (
    <>
      <Seo title="Methodology" description="How BrandPassport researches brand transparency." canonicalPath="/methodology" locale={locale} />
      <div className="bp-container py-16 max-w-3xl">
        <h1 className="font-serif text-5xl mb-6">Methodology</h1>
        <div className="space-y-5 text-base md:text-lg leading-relaxed" style={{ color: "var(--bp-text-secondary)" }}>
          <p>Each brand&apos;s transparency profile is built by researching seven categories aligned to the Digital Product Passport: product identity, materials, origin, repair &amp; care, end of life, environmental footprint, and certifications.</p>
          <p>For each category, editors record one of three statuses: <b>Found</b>, <b>Partial</b>, or <b>Not found in public sources</b>. Every non-empty status is anchored to a source URL and a retrieval date. Absence is recorded neutrally: it does not imply the brand fails to do the underlying work.</p>
          <p>We do not compute scores, ratings, grades, or rankings. The DPP readiness note reports a factual count of categories publicly documented, never a percentage or a gauge.</p>
        </div>
      </div>
    </>
  );
}
